import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Building, ThreeDotsVertical } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import OutsideClickClose from '../../OutsideClickClose'
import EditOptions from './EditOptions'
import ArchiveModal, { pluralize } from './ArchiveModal'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function ClientsListItem({ client, setOpenDeleteModal }) {
  const { browseState } = useContext(BrowseContext)
  const navigate = useNavigate()
  const [openEdit, setOpenEdit] = useState(false)
  const [archiveModalOpen, setArchiveModalOpen] = useState(false)

  return (
    <div
      className='border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode p-2 rounded-lg flex justify-between items-center hover:cursor-pointer'
      onClick={() => navigate(`/project_manager/campaigns/clients/${client.id}`)}
    >
      <div className="flex items-center">
        {
          client.avatar ?
            <img src={client.avatar} alt={client.name} className='w-12 h-12 rounded-lg' /> :
            <Building
              className={`p-3 rounded-lg text-5xl ${client.theme_color ? '' : 'border-1 border-rb-black dark:border-rb-dark-mode-lighter'}`}
              style={{ backgroundColor: client.theme_color, color: client.theme_color? '#FFF' : '#2C3E50' }}
            />
        }
        <div className='pl-3 flex flex-col items-start'>
          <p className='rb-text-muted text-sm'>Client</p>
          <h4 className='text-md font-bold dark:text-white'>{client.name}</h4>
        </div>
      </div>
      <div className='flex gap-3 items-center'>
        <span className='h-10 w-10 rounded-full bg-rb-grey dark:bg-rb-dark-mode-lighter flex justify-center items-center dark:text-white'>
          <span>{client.campaign_count}</span>
        </span>
        <span className='relative'>
          <button
            type='button'
            className='h-10 w-10 rounded-lg hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter flex justify-center items-center dark:text-white'
            onClick={(e) => {
              e.stopPropagation()
              setOpenEdit(!openEdit)
            }}
          >
            <ThreeDotsVertical />
          </button>
          <OutsideClickClose
            isOpen={openEdit}
            onClose={() => {
              setOpenEdit(false)
            }}
          >
            <EditOptions
              isOpen={openEdit}
              onEdit={() => {
                browseState.selectedClient = client
                browseState.toggleEditClient()
              }}
              onDelete={() => {
                browseState.selectedClient = client
                browseState.toggleDeleteClient()
              }}
              onArchive={() => setArchiveModalOpen(true)}
              onClose={() => {
                setOpenEdit(false)
              }}
            />
          </OutsideClickClose>
        </span>
        <span onClick={e => e.stopPropagation()}>
          <ArchiveModal
            isOpen={archiveModalOpen}
            onClose={() => setArchiveModalOpen(false)}
            title="Archive client"
            name={client.name}
            description={`Its ${pluralize(client.folder_count, 'folder')} and ${pluralize(client.campaign_count, 'campaign')} will be archived too, and its client share link will be turned off. Restoring the client restores everything inside it.`}
            onConfirm={() => browseState.archiveClient(client)}
          />
        </span>
      </div>
    </div>
  )
})
